import './css/App.css';
import { Link } from "react-router-dom"; 
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';

export default function Header(basename:any) {
  const basename_path  = basename['basename'];

  const refreshPage = (route:string) => {
    window.location.replace("/"+basename_path+"/"+route);
  }

  return (
    <div className="app-root">
      <AppBar position="static"  sx={{background: 'linear-gradient(45deg, #416261 20%, #F9f9f9 90%)'}} >
        <Toolbar >
          <Typography variant="h6" className="app-title" sx={{ flexGrow: 1 }}>
          <Link to="/" style={{ color: "white", textDecoration:"none" }}>VISTA Enhancer Browser</Link>          
          </Typography> 
          <Link to="/" style={{textDecoration: "none",fontWeight: "bold"}}><Button>HOME</Button></Link>
          <Link to="/browse" style={{textDecoration: "none",fontWeight: "bold"}} onClick={()=>refreshPage("browse")}><Button>BROWSE</Button></Link>
          <Link to="/advanced" style={{textDecoration: "none",fontWeight: "bold"}}><Button>ADVANCED SEARCH</Button></Link>  
          <Link to="/gallery" style={{textDecoration: "none",fontWeight: "bold"}}><Button>IMAGE GALLERY</Button></Link>  
          <Link to="/manual" style={{textDecoration: "none",fontWeight: "bold"}}><Button>MANUAL</Button></Link>  
          <Link to="/downloads" style={{textDecoration: "none",fontWeight: "bold"}}><Button>DOWNLOADS</Button></Link>  
          <Link to="/contact" style={{textDecoration: "none",fontWeight: "bold"}}><Button>CONTACT US</Button></Link>  
        </Toolbar>
      </AppBar>
    </div>
  );

 
}
 
